module.exports = __webpack_public_path__ + "1b6d22c6.png";